const noticeTypeToRussian = {
  PUSH: 'Push уведомления',
  PHONE: 'Обзвон',
  EMAIL: 'E-mail рассылка',
  SMS: 'SMS рассылка',
};

export default noticeTypeToRussian;
